import React, { useState } from "react";
import "../../assets/css/style.css";

import "jspdf-autotable";
import { ThreeDot } from "react-loading-indicators";
import NoAccess from "../../assets/img/NoAccess.png";

import OldBankBudgeting from "./components/Bank Budgeting/oldBankBudgeting";
import NewBankBudgeting from "./components/Bank Budgeting/newBankBudgeting";
const BankBudgeting = ({ authrztn }) => {
  const [isLoading] = useState(false);
  const [selectedValue] = useState("NEW");
  return (
    <div className="h-100 w-100 border bg-white custom-container">
      {isLoading ? (
        <div className="loading-container">
          <ThreeDot
            variant="brick-stack"
            color="#6290FE"
            size="large"
            text="Loading Data..."
            textColor=""
          />
        </div>
      ) : authrztn.includes("BankBudgeting-View") ? (
        <>
          {selectedValue === "OLD" ? (
            <OldBankBudgeting />
          ) : selectedValue === "NEW" ? (
            <NewBankBudgeting authrztn={authrztn} />
          ) : null}
        </>
      ) : (
        <div className="no-access">
          <img src={NoAccess} alt="NoAccess" className="no-access-img" />
          <h3>You don't have access to this function.</h3>
        </div>
      )}
    </div>
  );
};

export default BankBudgeting;
